import React from 'react'
import { Button, type ButtonSizeValue } from '@mc/design-system'
import { EnhancedCtaCopy, useAnnualPass, usePrimaryCta } from '@mc/growth'
import { trackCtaClicked } from '../../lib/events'

interface SignUpButtonProps {
  className?: string
  size?: ButtonSizeValue
  fullWidth?: boolean
  location: string
  pageSource?: string
  href: string
  trackingProps?: Record<string, unknown> | null
  onClick?: () => void
}

export const SignUpButton = ({
  className = '',
  size = 'md',
  fullWidth = false,
  location,
  pageSource,
  href,
  trackingProps,
  onClick = () => {},
}: SignUpButtonProps) => {
  const { ctaCopy } = usePrimaryCta()
  const annualPass = useAnnualPass()

  return (
    <Button
      fullWidth={fullWidth}
      className={className}
      onClick={() => {
        trackCtaClicked({
          action: ctaCopy,
          location,
          pageSource,
          href,
          annualPass,
          ...(trackingProps && { purchaseClickProps: trackingProps }),
        })
        onClick?.()
      }}
      render={<a href={href} />}
      size={size}
    >
      <EnhancedCtaCopy>{ctaCopy}</EnhancedCtaCopy>
    </Button>
  )
}
